import styled from 'styled-components';

import { MpBadge } from 'shared/ui/Badge/Badge';

export const SubscriptionsManagementContainerStyled = styled.section`
	padding: 40px 0;
	min-height: 40vh;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: calc(100vw - 32px);
		margin: 0 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
		margin: 0 auto;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 688px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 1200px;
	}
`;

export const SubscriptionNameContainerStyled = styled.div`
	flex-direction: column;
`;

export const SubscriptionsManagementSubtextStyled = styled.p`
	margin: 0;
	color: #8c8c8c;
	font-weight: 400;
	font-size: 12px;
`;

export const SubscriptionsManagementLoadingContainerStyled = styled.section`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 auto;
	padding: 40px 0;
	min-height: 40vh;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 328px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 688px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 1200px;
	}
`;

export const SubscriptionsManagementHeaderStyled = styled.h1`
	margin-bottom: 24px;
	font-weight: 600;
	font-size: 30px;
`;

export const BadgeStyled = styled(MpBadge)`
	top: 7px;
	right: -7px;
`;
